import { render, staticRenderFns } from "./NsCheckbox.vue?vue&type=template&id=c78eba94&scoped=true&"
import script from "./NsCheckbox.vue?vue&type=script&lang=js&"
export * from "./NsCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./NsCheckbox.vue?vue&type=style&index=0&id=c78eba94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c78eba94",
  null
  
)

export default component.exports